import * as React from 'react';
import { Typography } from '@catapultsports/referee-react';
import { ChangeEvent } from 'react';
import styles from './radio-button.module.css';

interface RadioButtonProps {
    value: string;
    isChecked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    label: string;
    description?: string;
    name: string;
    disabled: boolean;
}
export const RadioButton: React.FC<RadioButtonProps> = (props) => {
    const { value, isChecked, onChange, label, description, disabled, name } = props;
    return (
        <div className={styles['radio-button-grid']}>
            <div className={styles['radio-button-selector']}>
                <input
                    type="radio"
                    id={value}
                    name={name}
                    value={value}
                    checked={isChecked}
                    onChange={onChange}
                    disabled={disabled}
                />
            </div>
            <Typography color={disabled ? 'tertiary' : 'catapult-black'} variant="label-1">
                {label}
            </Typography>
            <Typography color={disabled ? 'tertiary' : 'catapult-black'} variant="body-1">
                {description}
            </Typography>
        </div>
    );
};
